// Capacitor native-runtime bootstrap. Runs once at app start.
// On web (PWA / desktop browser) this file is a complete no-op so the
// bundle size impact is negligible.

// Shared native-platform check — used to gate any in-app purchase-initiating
// UI (App Store Guideline 3.1.1: paid content must go through IAP, so the
// native build must not offer a non-IAP purchase path; web is unaffected).
export function isNativePlatform() {
  if (typeof window === 'undefined') return false;
  const cap = window.Capacitor;
  return !!(cap && cap.isNativePlatform && cap.isNativePlatform());
}

export async function initNativeShell() {
  if (typeof window === 'undefined') return;
  const cap = window.Capacitor;
  const isNative = !!(cap && (cap.isNativePlatform ? cap.isNativePlatform() : false));
  if (!isNative) return;

  // ─── StatusBar — make it OPAQUE so the WebView starts below it.
  // Without this, Android renders edge-to-edge by default and the status
  // bar overlaps every AppBar. The native config in capacitor.config.ts
  // sets style + color but does NOT control `overlaysWebView`.
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0F172A' });
  } catch (e) {
    // Plugin not installed or runtime error — silent. The CSS safe-area
    // fallback in index.css still handles the overlap.
    console.warn('StatusBar init failed', e);
  }
}
